var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"voucher"},[_c('div',{staticClass:"voucher_container"},[_c('ReceiptDetails',{attrs:{"id":_vm.id,"isGuest":true,"taxpayer":{},"showHeader":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }